import { Button, Modal } from 'react-bootstrap'
import {
    Typography
} from '@material-ui/core'
import React, { useLayoutEffect, useEffect, useState, useRef } from 'react';
import { getUserFactoryId } from '../../../../index';
import api from '../../../services/api';
import { SetorLinhaMaquina } from '../../../containers/filter';
import {
    recursiveGetElementsByKey,
    recursiveGetIds
} from '../../../helpers/three';
import { useFilters } from '../../../containers/filter/_redux/slice';
import _ from "lodash";
import buildQuery from 'odata-query'
import Select from "react-select";
import { SelectAsyncPaginateStandards } from '../../Select/';

export function ExternalStandardModal({ structureId = null, showModalDoc, standardOptions, onHide, onAccept }) {
    const { struct } = useFilters();

    const [standardId, setStandardId] = useState(0);
    const [ filterState, setFilters ] = useState({
        standardType: standardOptions.length > 0 ? standardOptions[0].value : 'lpp',
        structureId: structureId
    })

    useLayoutEffect(() => {

        if (showModalDoc) {
            PrepareData();
        }

        async function PrepareData() {    
            console.log(structureId)           
            const standardType = standardOptions.length > 0 ? standardOptions[0].value : 'lpp'  
            setFilters(
                {
                    standardType: standardType,
                    structureId: structureId
                }
            )                
        }
            
    }, [showModalDoc])

    async function handleChangeItem(e) {
        console.log(e)
        if (e.id != undefined)
            await setStandardId(e.id)      
    }

    async function handleChangeType(e) {    
        const standardType =  e.target.value
        console.log(e.target)
        setFilters((oldValue) => {
            return {
                ...oldValue,
                standardType: standardType
            }
        })        
    }

    const onTreeSelect = (currentNode, selectedNode) => {
        
        if(!selectedNode || !selectedNode.id) {
            return false;
        }
        
        setFilters((oldValue) => {
            return {
                ...oldValue,
                structureId: selectedNode.id
            }
        })
    }

    return (
        <>
            { showModalDoc &&
            <>           
                <Modal show={showModalDoc} onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Linkar a outro documento?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <label className='w-100'>
                            Tipo de documento
                  <select className='form-control' onChange={handleChangeType}>
                                {standardOptions.map((op) => (
                                    (typeof op === "object") ?
                                        <option key={'op' + (op.key || op.id)} value={op.value.toUpperCase() || op.name.toUpperCase()}> {op.value.toUpperCase() || op.name.toUpperCase()} </option>
                                        :
                                        <option key={'op' + op} value={op}> {op} </option>
                                ))}
                            </select>
                            </label>        
                            <Typography className='m-0'>Setor/Linha/Máquina</Typography>
                        <SetorLinhaMaquina
                            onChange={onTreeSelect} />    
                    </div>
                                           
                        <div className="standardList" style={{marginTop: "20px"}}>
                        <p>Nome do documento:</p>     
                            <SelectAsyncPaginateStandards
                                structureId={filterState.structureId}
                                standardType={filterState.standardType}
                                onChangeCallback={handleChangeItem}
                            />
                        </div>
                </Modal.Body>
                <Modal.Footer>
                        <Button variant="danger" onClick={onHide}>
                        Cancelar
              </Button>
                        <Button variant="success" onClick={(e) => onAccept(standardId, filterState.standardType, standardId !== 0)}>
                        Enviar
              </Button>
                </Modal.Footer>
                </Modal>
            </>
        }
    </>
    )
}